import { ErrorHandler, Injectable } from '@angular/core';

/** Keep Angular's error reporting so unexpected failures remain diagnosable. */
@Injectable()
export class GlobalErrorHandler extends ErrorHandler {}
